// extracted by mini-css-extract-plugin
export default {"Header":"Dialogue_Header__3Vydm","Footer":"Dialogue_Footer__b2Puh"};